export enum PlanName {
  // - archived plans
  // TODO: once clean up the organization's subscription
  // (i.e. move away from these legacy plans), remove from this enum list
  ArchivedStartupMonthly = 'archived-startup-monthly',
  ArchivedTeamsYearly = 'archived-teams-yearly',
  ArchivedTeamsMonthly2 = 'archived-teams-monthly-2',
  StartupYearly = 'startup_yearly',
  StartupMonthly = 'startup_monthly',
  TeamsMonthly = 'teams_monthly',
  TeamsYearly = 'teams_yearly',
  StandardMonthly = 'standard_monthly',
  StandardYearly = 'standard_yearly',
  // - active plans that are promoted to users in app
  Enterprise = 'enterprise',
  StorageMonthly = 'storage_monthly',
  TrackingMonthly = 'tracking_monthly',
  Basic = 'basic',
  StarterTier1Monthly = 'starter_tier_1_monthly',
  StarterTier1Yearly = 'starter_tier_1_yearly',
  StarterTier2Monthly = 'starter_tier_2_monthly',
  StarterTier2Yearly = 'starter_tier_2_yearly',
  StarterTier3Monthly = 'starter_tier_3_monthly',
  StarterTier3Yearly = 'starter_tier_3_yearly',
}
